// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2sXn1","modalFooterButton":"ModalNotes_modalFooterButton__2LNH-"};